import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../Context/AuthContext";
import { useAlertContext } from "../Context/AlertContext";
import AuthAlerts from "./Auth/components/AuthAlerts";
import AuthShell from "./Auth/components/AuthShell";
import VerifyView from "./Auth/components/VerifyView";
import "./Auth/auth-theme.css";

const Verification = () => {
  const [code, setCode] = useState("");
  const [username, setUsername] = useState("");
  const [resending, setResending] = useState(false);
  const [inlineError, setInlineError] = useState("");
  const { submitting, confirmSignup } = useAuthContext();
  const { t } = useTranslation("common");
  const { state } = useLocation();
  const { setSuccess, setError, errors, clearErrors } = useAlertContext();
  const navigate = useNavigate();
  const siteName = process.env.REACT_APP_WESITE_NAME || "Odoo API";
  const emailLocked = Boolean(state?.email);

  useEffect(() => {
    if (state?.email) {
      setUsername(state.email);
    }
  }, [state?.email]);

  useEffect(() => {
    document.body.classList.add("auth-active");
    document.body.classList.remove("landing-active", "forgot-auth-active");
    return () => {
      document.body.classList.remove("auth-active");
    };
  }, []);

  useEffect(() => {
    if (errors?.message) {
      setInlineError(errors.message);
    }
  }, [errors]);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      setInlineError("");
      clearErrors();
      try {
        await confirmSignup(username, code);
        setSuccess(t("Verification done! you can login now."), true);
        navigate("/login");
      } catch (e) {
        setInlineError(e.message || t("Verification failed. Please try again."));
      }
    },
    [username, code, confirmSignup, clearErrors, setSuccess, t, navigate]
  );

  const resendCode = async () => {
    try {
      setResending(true);
      setInlineError("");
      clearErrors();
      await Auth.resendSignUp(username);
      setSuccess(t("Verification code has been sent to your email address."));
    } catch (e) {
      console.log(e);
      setError(e.message);
      setInlineError(e.message);
    } finally {
      setResending(false);
    }
  };

  return (
    <>
      <AuthAlerts />
      <AuthShell>
        <VerifyView
          siteName={siteName}
          username={username}
          code={code}
          emailLocked={emailLocked}
          submitting={submitting}
          resending={resending}
          inlineError={inlineError}
          onUsernameChange={setUsername}
          onCodeChange={setCode}
          onSubmit={handleSubmit}
          onResendCode={resendCode}
          onLoginClick={() => navigate("/login")}
        />
      </AuthShell>
    </>
  );
};

export default Verification;
